import {
  Box,
  Flex,
  Text,
  VStack,
  HStack,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { extractName, getRemainingInfo } from "../../utils";
import AvatarComponent from "../avatar";
import { FiArrowRight } from "react-icons/fi";

const RecentEntriesTab = ({ entries = [] }) => {
  const navigate = useNavigate();
  
  return (
    <VStack spacing={4} align="stretch">
      {entries.slice(0, 3).map((entry, index) => (
        <RecentEntry
          key={index}
          fullname={extractName(entry.message)}
          info={getRemainingInfo(entry.message)}
          image={entry.image_data}
        />
      ))}

      {entries.length > 0 && (
        <Flex justifyContent="flex-end" pt={2}>
          <Button
            variant="ghost"
            size="sm"
            rightIcon={<FiArrowRight />}
            onClick={() => navigate(ROUTES.entries)}
            color="blue.600"
            _hover={{ bg: "blue.50" }}
          >
            View all entries
          </Button>
        </Flex>
      )}
    </VStack>
  );
};

export default RecentEntriesTab;

const RecentEntry = ({ fullname, info, image }) => {
  return (
    <Box
      bg="gray.50"
      borderRadius="12px"
      p={4}
      border="1px solid"
      borderColor="gray.200"
      _hover={{ bg: "gray.100" }}
      transition="all 0.2s"
    >
      <HStack spacing={4} align="center">
        <Box>
          <AvatarComponent name={fullname} image={image} />
        </Box>
        <VStack spacing={1} align="start" flex={1}>
          <Text fontWeight="600" fontSize="md" color="gray.900">
            {fullname}
          </Text>
          <Text fontSize="sm" color="gray.600">
            {info}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};
